import type { DomainManifest } from 'modules/core/lib/manifests/types'

import { DeviceRecommendationsActivity } from 'modules/it_management/activities/DeviceRecommendations'
import { sidebarManifest } from './sidebar'

export const manifest = {
  sidebar: (navigation) => ({
    items: sidebarManifest(navigation),
  }),
  activities: {
    previewDeviceCatalog: {
      component: DeviceRecommendationsActivity,
      availableForOne: true,
      guidelines:
        'Show a popup with device recommendations fetched from the product catalog by their variant IDs. Each card displays the product image, price, delivery info, and has "Add to cart" and "View details" buttons. Use when the user asks for device recommendations and you have fetched matching product IDs from the catalog API.',
      params: {
        title: {
          guidelines:
            'Optional heading for the popup. Use a short phrase such as "Recommended laptops for designers".',
        },
        description: {
          guidelines: 'Optional short explanation of why these devices were selected.',
        },
        search: {
          guidelines:
            'Optional. Search text to preserve if the user clicks through to the full catalog.',
        },
        productIds: {
          guidelines:
            'Required. JSON array of distributor product variant ID strings. The activity will fetch full product details from the catalog API using these IDs.',
        },
      },
    },
  },
} as const satisfies DomainManifest
